import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React, { Suspense } from "react";
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';

import authReducer from './store/reducers/auth';
import wizardReducer from './store/reducers/wizard';
import inventoryReducer from './store/reducers/inventory';
import modalReducer from './store/reducers/modals';
import statsReducer from './store/reducers/stats';

import { transitions, positions, Provider as AlertProvider } from 'react-alert'
import AlertTemplate from './components/Shared/AlertTemplate'

import './i18n';
import {Helmet} from "react-helmet";


// Alert configuration
const options = {
  position: positions.TOP_CENTER,
  timeout: 3000,
  offset: '30px',
  transition: transitions.SCALE,
  containerStyle: {}
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
    auth: authReducer,
    wizard: wizardReducer,
    inventory: inventoryReducer,
    modal: modalReducer,
    stats: statsReducer,
});


const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(thunk)
));


const app = (
  <div className="application">
  <Helmet>
      <meta charSet="utf-8" />
      <title>Rudolf Hensel | Product Selector</title>
  </Helmet>

  <Provider store={store}>
    <BrowserRouter>
      <AlertProvider template={AlertTemplate} {...options}>
        <Suspense fallback={<div></div>}>
          <App />
        </Suspense>
      </AlertProvider>
    </BrowserRouter>
  </Provider>
  </div>
)

ReactDOM.render( app, document.getElementById( 'root' ) );
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js